import React, { Component } from 'react';

import { connect } from 'react-redux'
import ManageUsers from './components/ManageUsers/ManageUsers'

import {
  fetchAddAgent,
  fetchSlimAccount
} from 'broker/redux/account'

const mapDispatchToProps = dispatch => ({
    dispatch
})

class ManageUsersContainer extends Component {
    componentDidMount() {
      const { dispatch } = this.props
      dispatch(fetchSlimAccount())
      dispatch(fetchAddAgent())
    }

    render() {
        return <ManageUsers {...this.props} />
    }
}

export default connect((state) => ({ auth: state.auth }), mapDispatchToProps)(ManageUsersContainer)
